import React from 'react';
import PropTypes from 'prop-types';

/**
 * Label component for form inputs
 */
const Label = ({ 
  children,
  htmlFor,
  required = false,
  className = '',
  size = 'md',
  ...props 
}) => {
  const baseClasses = "block font-medium text-gray-700";
  
  const sizeClasses = {
    sm: "text-sm mb-1",
    md: "text-sm mb-2",
    lg: "text-base mb-2"
  };

  return (
    <label
      htmlFor={htmlFor}
      className={`${baseClasses} ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {children}
      {required && <span className="text-red-500 ml-1">*</span>}
    </label>
  );
};

Label.propTypes = {
  children: PropTypes.node.isRequired,
  htmlFor: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};

export default Label;
